$(document).ready(function() {
    $('.ttgNewsKategorienFilterHeadlineMobile').click(function(){
        $('.ttgNewsFilterWrapper').toggle();
        $(this).toggleClass('ttgNewsFilterHeadlineHover');
    });
	
});